import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { useStore } from 'src/stores';
import useStyles from './styles';
export default function AccountMaintananceFee(_ref) {
  let enrolled = _ref.enrolled,
    propertyConfigMode = _ref.propertyConfigMode,
    subscriptionName = _ref.subscriptionName;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(5),
    _useState2 = _slicedToArray(_useState, 2),
    accMF = _useState2[0],
    setAccMF = _useState2[1];

  /* NOTE: Currently Disabled because usage of tiers is suspended
  let amf,
    remainder,
    limit = 20;
  if (enrolled > 20) {
    amf = 6;
    remainder = 0;
  } else if (enrolled > 10) {
    amf = 8;
    remainder = 20 - enrolled;
  } else {
    amf = 10;
    limit = 10;
    remainder = 10 - enrolled;
  }
  */

  useEffect(() => {
    store.payment.getStripeProductAsync.run({
      productName: 'Unit Subscription Fee'
    }).then(data => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      data.defaultAmount && setAccMF(data.defaultAmount);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.sectionWrapper, " ").concat(propertyConfigMode ? classes.propertyConfigMode : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.section
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, subscriptionName), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "$", Number(accMF * enrolled).toFixed(2), "/", t('general.month').toLowerCase())), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.rationBillingSection, " ").concat(propertyConfigMode ? classes.lastSection : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.ratioBilling
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('subscriptions.ratio_billing_per_unit_fee')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, enrolled, " x $", Number(accMF).toFixed(2))), !enrolled ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('subscriptions.no_added_property_yet')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    component: RouterLink,
    to: "/new_property",
    'custom-attribute': '467-account-maintanance-fee'
  }, t('subscriptions.add_property')))) : null), !propertyConfigMode && false && /*#__PURE__*/React.createElement("div", {
    className: classes.subSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Mock Billing per unit fee"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, enrolled, " x $1.00")));
}